import React, { useState, useEffect } from 'react';
import { useSettings } from '../../contexts/SettingsContext';
import { getCurrentTime } from '../../utils/helpers';
import styles from './SystemTray.module.css';

export const SystemTray: React.FC = () => {
  const [time, setTime] = useState(getCurrentTime());
  const { settings, toggleSound } = useSettings();

  // Update time every minute
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(getCurrentTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.systemTray} role="region" aria-label="System tray">
      <div className={styles.trayLeft}>
        {/* Expand button */}
        <button className={styles.expandButton} aria-label="Show hidden icons">
          <svg width="8" height="8" viewBox="0 0 8 8" fill="currentColor">
            <path d="M0 2 L4 6 L8 2 Z"/>
          </svg>
        </button>
      </div>

      <div className={styles.trayIcons}>
        {/* Volume icon */}
        <button
          className={styles.trayIcon}
          onClick={toggleSound}
          title={settings.soundEnabled ? 'Sound: On' : 'Sound: Muted'}
          aria-label={settings.soundEnabled ? 'Mute sound' : 'Unmute sound'}
        >
          {settings.soundEnabled ? (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <path d="M2 5 L2 11 L5 11 L10 15 L10 1 L5 5 Z"/>
              <path d="M12 5 C13 6 13 10 12 11" fill="none" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M13 3 C15 5 15 11 13 13" fill="none" stroke="currentColor" strokeWidth="1.5"/>
            </svg>
          ) : (
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <path d="M2 5 L2 11 L5 11 L10 15 L10 1 L5 5 Z"/>
              <path d="M12 5 L15 11 M15 5 L12 11" stroke="currentColor" strokeWidth="1.5" fill="none"/>
            </svg>
          )}
        </button>
      </div>

      <div className={styles.clock} aria-label={`Current time: ${time}`}>
        {time}
      </div>
    </div>
  );
};

export default SystemTray;
